// var lang = document.documentElement.lang;
var base_site_url = window.location.protocol + "//" + window.location.host;
// var site_url_locatized = base_site_url + '/' + lang;

export const Config = {
  api: {
    // getTranslatedStrings: site_url_locatized + '/api/frontend-component/translated-strings',
    getTranslatedStrings: base_site_url + '/app/api/frontend-component/translated-strings',
  }
};